import * as yup from "yup";
interface RC4ValidationSchemaProps {
  languageSpecialization: boolean;
}

const RC4ValidationSchema = ({
  languageSpecialization,
}: RC4ValidationSchemaProps) => {
  let schema = yup.object().shape({
    name: yup
      .string()
      .max(60, "Name cannot exceed 60 characters")
      .required("Name is required"),
    address: yup
      .string()
      .max(100, "Address cannot exceed 60 characters")
      .required("Address is required"),
    phone: yup
      .string()
      .required("Phone Number is required")
      .min(10, "Invalid Phone Number")
      .max(11, "Invalid Phone Number"),
    email: yup
      .string()
      .max(50, "Email cannot exceed 50 characters")
      .required("Email is required")
      .email("Invalid Email"),

    website: yup
      .string()
      .max(150, "Website cannot exceed 150 characters")
      .url("Invalid Website")
      .required("Website is required"),

    description: yup
      .string()
      .max(1000, "Max character limit reached")
      .required("Description is required"),

    description2ngLanguage: yup.string(),
  });

  const secondLanguageFields = {
    description2ngLanguage: yup
      .string()
      .max(1000, "Max character limit reached")
      .required("Description in second language is required"),
  };

  if (languageSpecialization) {
    schema = schema.shape(secondLanguageFields);
  }

  return schema;
};

const RCIVSchema = yup.object().shape({
  name: yup
    .string()
    .max(60, "Name cannot exceed 60 characters")
    .required("Name is required"),
  address: yup
    .string()
    .max(100, "Address cannot exceed 60 characters")
    .required("Address is required"),
  phone: yup
    .string()
    .required("Phone Number is required")
    .min(10, "Invalid Phone Number")
    .max(11, "Invalid Phone Number"),
  email: yup
    .string()
    .max(50, "Email cannot exceed 50 characters")
    .required("Email is required")
    .email("Invalid Email"),

  website: yup
    .string()
    .max(150, "Website cannot exceed 150 characters")
    .url("Invalid Website")
    .required("Website is required"),
});

const schemaRCIV = { RC4ValidationSchema, RCIVSchema };
export default schemaRCIV;
